/**
 * Add a "Show more" mechanism to the product description
 */
function arsProductDescription() {

  /**
   * Find the first description container in the DOM
   *
   * @returns {null|object}
   */
  function getContainer() {
    const element = document.querySelector(".product__description")
    // Do nothing if no target element can be found
    if (element === null) {
      return null
    }
    // Do nothing if the product description is short, e.g. less than 1.000 characters
    if (element.textContent.length < 1000) {
      return null
    }
    return element
  }

  const iconPlus = `<span class="ars-icon ars-mr-2">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path class="ars-icon--secondary" d="M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm112 0c0-8.8 7.2-16 16-16l80 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16z" />
        <path class="ars-icon--primary" d="M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 352c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 80z" />
      </svg>
    </span>`

  const iconMinus = `<span class="ars-icon ars-mr-2">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path class="ars-icon--secondary" d="M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm112 0c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16z" />
        <path class="ars-icon--primary" d="M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0z" />
      </svg>
    </span>`

  /**
   * Add the trigger to the bottom of the description container
   *
   * @params {object} container
   * @returns {void}
   */
  function add(container) {
    // Flag the container
    container.classList.add("ars-product-description")
    // Create the trigger element
    const element = `<div class="ars-product-description__more">
      <button type="button" class="button button--secondary ars-product-description__trigger">
        ${iconPlus}<span>Mehr anzeigen</span>
      </button>
    </div>`
    // Add the trigger to the bottom of the container
    container.innerHTML += element
  }

  /**
   * Listen to clicks on the trigger button
   *
   * @params {object} container
   * @returns {void}
   */
  function listen(container) {
    const containerActiveClass = "ars-product-description--act"
    const triggerActiveClass = "ars-product-description__trigger--act"
    const trigger = document.querySelector(".ars-product-description__trigger")
    if (trigger === null) {
      return
    }
    trigger.addEventListener("click", function() {
      trigger.classList.toggle(triggerActiveClass)
      if (trigger.classList.contains(triggerActiveClass)) {
        container.classList.add(containerActiveClass)
        trigger.innerHTML = `${iconMinus}<span>Weniger anzeigen</span>`
      } else {
        container.classList.remove(containerActiveClass)
        trigger.innerHTML = `${iconPlus}<span>Mehr anzeigen</span>`
      }
    })
  }

  // Control flow
  const container = getContainer()
  if (container === null) {
    return
  }
  add(container)
  listen(container)
}
arsProductDescription()

/**
 * Initialize the slider for product properties
 */
window.arsSlider(".ars-properties .ars-slider", {
  slidesPerView: 1,
  breakpoints: {
    "512": {
      slidesPerView: 2,
      spaceBetween: 24
    },
    "750": {
      slidesPerView: 3,
      spaceBetween: 32
    },
    "992": {
      slidesPerView: 4,
      spaceBetween: 32
    },
    "1200": {
      slidesPerView: 5,
      spaceBetween: 32
    },
  }
})

/**
 * Initialize the slider for product author profiles
 */
function arsProductAuthorsSlider() {
  // Sort the slides alphabetically by last name and first name
  function sortSlides()
  {
    // Iterate over all slider instances
    // NodeLists do not have a .sort() method, so we must convert them to an array
    const sliders = Array.from(document.querySelectorAll(".ars-product__authors"))
    sliders.forEach((slider) => {
      const wrapper = slider.querySelector(".swiper-wrapper")
      const slides = Array.from(slider.querySelectorAll(".ars-slider__slide"))
      // Sort the slides by HTML data attributes for the last and first name
      slides.sort((a, b) => {
        // Compare last names
        const lastNameA = a.dataset.lastName
        const lastNameB = b.dataset.lastName
        const compare = lastNameA.localeCompare(lastNameB)
        if (compare !== 0) {
          return compare
        }
        // If last names are equal, compare first names
        const firstNameA = a.dataset.firstName
        const firstNameB = b.dataset.firstName
        return firstNameA.localeCompare(firstNameB)
      });
      // Re-insert sorted elements into the DOM
      wrapper.innerHTML = ""
      slides.forEach(slide => wrapper.appendChild(slide))
    })
  }

  // Init SwiperJS
  function initSwiper()
  {
    window.arsSlider(".ars-product__authors .ars-slider", {
      slidesPerView: 1,
      spaceBetween: 32,
      breakpoints: {
        "750": {
          slidesPerView: 2
        },
        "992": {
          slidesPerView: 3
        },
        "1200": {
          slidesPerView: 2
        }
      }
    })
  }

  // Init
  sortSlides()
  initSwiper()
}
arsProductAuthorsSlider()

/**
 * Initialize the slider reviews
 */
window.arsSlider(".ars-reviews .ars-slider", {
  breakpoints: {
    "750": {
      slidesPerView: 2
    },
    // "992": {
      // slidesPerView: 3
    // }
  },
  slidesPerView: 1,
  spaceBetween: 32,
})